import React from "react";
import Seo from "../components/shared/seo";
import Hero from "../components/cookiesPage/hero";
import Layout from "../components/shared/layout";
import { useIntl } from "gatsby-plugin-react-intl";

function Cookies() {
  const intl = useIntl();

  return (
    <Layout>
      <Seo
        title={intl.formatMessage({
          id: "CookiesPageTitle",
        })}
        description={intl.formatMessage({
          id: "CookiesPageDescription",
        })}
      />
      <Hero />
    </Layout>
  );
}

export default Cookies;
